import { CreateSubjectType } from "../../../types/Subject";
import { SubjectPlanType } from "../../../types/SubjectPlan";
import { post } from "../../../utils/axios-config";
import { SUBJECTS_PLAN, SUBJECTS } from "../../../utils/constants";

export const createSubject = async (data: CreateSubjectType) => {
    return await post<CreateSubjectType, string>(SUBJECTS, data);
  };


  
export const createSubjectPlan = async (data: SubjectPlanType) => {
  return await post<SubjectPlanType, string>(SUBJECTS_PLAN, data);
};